import useUnread from "../useUnread";
import { formatCount } from "../formatCount";
import styles from "./messenger-count-badge.module.css";

/**
 * Красный кружок с числом диалогов с непрочитанным поверх кнопки мессенджера.
 * Рисуется рядом с кнопкой (она position: fixed) и не перехватывает щелчки.
 */
export default function MessengerCountBadge({ config }) {
  const { messenger } = useUnread(config);

  if (!messenger.count) {
    return null;
  }

  return (
    <span className={styles.badge} aria-hidden="true">
      {formatCount(messenger.count)}
    </span>
  );
}
